module.exports = __webpack_public_path__ + "static/img/A171.a461b1ca.jpg";